import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

const BASE = process.env.REACT_APP_API_BASE || "http://localhost/twinpack/php";

const ProspeccionDescartarModal = ({ prospectoId, onClose, onSaved }) => {
  const [motivo, setMotivo] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!motivo.trim()) return toast.error("El motivo es obligatorio");
    setSubmitting(true);
    try {
      const fd = new FormData();
      fd.append("id", prospectoId);
      fd.append("motivo_descarte", motivo);
      const r = await axios.post(`${BASE}/prospectos_descartar.php`, fd);
      if (r.data?.success) {
        toast.success("Prospecto descartado");
        if (onSaved) onSaved();
      } else {
        toast.error(r.data?.mensaje || "Error al descartar");
        setSubmitting(false);
      }
    } catch {
      toast.error("Error de conexión");
      setSubmitting(false);
    }
  };

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <h2 style={{ margin: "0 0 8px", fontSize: 18, fontWeight: 700, color: "#dc2626" }}>
          🗑 Descartar prospecto
        </h2>
        <p style={{ margin: "0 0 16px", color: "#666", fontSize: 13 }}>
          El prospecto saldrá del embudo activo. Podés reactivarlo después si hace falta.
        </p>

        <form onSubmit={handleSubmit}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 700, color: "#888", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 6 }}>
            Motivo del descarte *
          </label>
          <textarea
            autoFocus
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Ej: No responde después de 4 toques. No es prioridad."
            style={{
              width: "100%", minHeight: 100,
              padding: "10px 12px", border: "1.5px solid #e0d6dc", borderRadius: 8,
              fontSize: 13, color: "#222", background: "#fafafa",
              outline: "none", boxSizing: "border-box", fontFamily: "inherit", resize: "vertical",
            }}
          />

          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 20 }}>
            <button type="button" onClick={onClose} disabled={submitting}
              style={{ padding: "10px 22px", background: "#fff", color: "#666", border: "1.5px solid #e0d6dc", borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              Cancelar
            </button>
            <button type="submit" disabled={submitting}
              style={{ padding: "10px 22px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>
              {submitting ? "Descartando…" : "Confirmar descarte"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

const overlay = { position: "fixed", top: 0, left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,0.45)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: 20 };
const modal = { background: "#fff", borderRadius: 14, padding: "24px 28px", maxWidth: 460, width: "100%", boxShadow: "0 8px 32px rgba(0,0,0,0.18)" };

export default ProspeccionDescartarModal;
